// Sue sticker-builder adapter for quote-3d.js.
// Classic script (not type=module). Only supported sticker/label products
// request quote-3d.js; its module load re-syncs the currently selected product.
//
// Contract: window.vpStickerPreview.sync() / .dispose()
// Another caller (updatePrice) is expected to invoke sync(); this file also
// loads VPQuote3D on demand and re-syncs once on window load.

(function () {
  var STICKER_CATS = {
    'custom-stickers': 1,
    'embossed-stickers': 1,
    'specialty-stickers': 1,
    'labels': 1
  };

  // quote-3d cut ids are die|kiss|tape|sheet|roll — never "diecut".
  var CHIP_CUT = {
    'die-cut': 'die',
    'circle': 'die',
    'square': 'die',
    'rectangle': 'die',
    'kiss-cut': 'kiss',
    'transfer': 'tape',
    'sheets': 'sheet',
    'clear': 'die',
    'vinyl-letter': 'tape',
    'static-cling': 'die',
    'front-adhes': 'die',
    'emb-die-cut': 'die',
    'emb-circle': 'die',
    'emb-square': 'die',
    'emb-rect': 'die',
    'emb-sheets': 'sheet',
    'lbl-circle': 'sheet',
    'lbl-die-cut': 'sheet',
    'lbl-oval': 'sheet',
    'lbl-rect': 'sheet',
    'lbl-rounded': 'sheet',
    'lbl-square': 'sheet',
    'lbl-roll': 'roll'
  };

  // Sample silhouettes are independent of cut construction and quoted options.
  var CHIP_SHAPE = {
    'circle': 'circle',
    'square': 'square',
    'rectangle': 'rectangle',
    'emb-circle': 'circle',
    'emb-square': 'square',
    'emb-rect': 'rectangle',
    'emb-perf': 'rectangle',
    'static-cling': 'rounded-rectangle',
    'front-adhes': 'circle',
    'lbl-circle': 'circle',
    'lbl-die-cut': 'die',
    'lbl-oval': 'oval',
    'lbl-rect': 'rectangle',
    'lbl-rounded': 'rounded-rectangle',
    'lbl-square': 'square',
    'lbl-roll': 'circle'
  };

  var mounted = false;
  var lastPayloadKey = '';
  var waiting = false;
  var moduleAttempts = 0;
  var loadTimer = null;

  function lower(s) {
    return String(s || '').toLowerCase();
  }

  function norm(s) {
    return lower(s).replace(/-/g, ' ');
  }

  function chipId() {
    return (typeof currentChipId !== 'undefined' && currentChipId) ? String(currentChipId) : '';
  }

  function productName() {
    var cat = (typeof CATEGORIES !== 'undefined' && typeof currentCat !== 'undefined')
      ? CATEGORIES[currentCat]
      : null;
    var fromCat = cat && (cat._customName || cat.name);
    if (fromCat) return String(fromCat);
    if (typeof SWITCHER_GROUPS !== 'undefined' && chipId()) {
      var id = chipId();
      var keys = Object.keys(SWITCHER_GROUPS);
      for (var i = 0; i < keys.length; i++) {
        var grp = SWITCHER_GROUPS[keys[i]];
        if (!grp) continue;
        for (var j = 0; j < grp.length; j++) {
          if (grp[j].id === id) return grp[j].name || grp[j].label || '';
        }
      }
    }
    return '';
  }

  function isExcluded(name, id) {
    var s = norm(name + ' ' + id);
    if (s.indexOf('mylar') !== -1) return true;
    if (s.indexOf('poster') !== -1) return true;
    if (s.indexOf('banner') !== -1) return true;
    if (s.indexOf('yard sign') !== -1) return true;
    if (s.indexOf('miron') !== -1) return true;
    if (s.indexOf('flower jar') !== -1) return true;
    if (s.indexOf('pre roll') !== -1 || s.indexOf('preroll') !== -1) return true;
    return false;
  }

  function cutFromName(name, id) {
    var s = norm(id + ' ' + name);
    if (s.indexOf('roll') !== -1 && s.indexOf('label') !== -1) return 'roll';
    if (s.indexOf('transfer') !== -1 || s.indexOf('vinyl letter') !== -1) return 'tape';
    if (s.indexOf('kiss') !== -1) return 'kiss';
    if (s.indexOf('sheet') !== -1) return 'sheet';
    if (s.indexOf('die') !== -1) return 'die';
    if (s.indexOf('circle') !== -1) return 'die';
    if (s.indexOf('square') !== -1) return 'die';
    if (s.indexOf('rect') !== -1) return 'die';
    return null;
  }

  function resolveCut(name, id) {
    if (CHIP_CUT[id]) return CHIP_CUT[id];
    var fromName = cutFromName(name, id);
    if (fromName) return fromName;
    // Sticker-category leftover (Gold Metallic, Reflective, glitter/holo
    // specialty chips, perforated) — die-cut mesh is the finish demo.
    return 'die';
  }

  function resolveShape(name, id) {
    if (CHIP_SHAPE[id]) return CHIP_SHAPE[id];
    var s = norm(id + ' ' + name);
    if (s.indexOf('static cling') !== -1) return 'rounded-rectangle';
    if (s.indexOf('front adhes') !== -1) return 'circle';
    if (s.indexOf('rounded') !== -1) return 'rounded-rectangle';
    if (s.indexOf('oval') !== -1) return 'oval';
    if (s.indexOf('roll label') !== -1 || s.indexOf('circle') !== -1) return 'circle';
    if (s.indexOf('square') !== -1) return 'square';
    if (s.indexOf('rect') !== -1) return 'rectangle';
    return 'die';
  }

  function isStickerProduct() {
    var cat = typeof currentCat !== 'undefined' ? currentCat : '';
    if (!STICKER_CATS[cat]) return false;
    var name = productName();
    var id = chipId();
    if (isExcluded(name, id)) return false;
    // Jar-label products keep their own preview; only catalog sheet/roll labels use this renderer.
    if (cat === 'labels' && !CHIP_CUT[id]) return false;
    return !!resolveCut(name, id);
  }

  function mapEmboss(name) {
    if (typeof vpQuoteEmboss === 'function') return vpQuoteEmboss();
    var cat = typeof currentCat !== 'undefined' ? currentCat : '';
    if (typeof currentEmboss !== 'undefined' && currentEmboss && currentEmboss !== 'none') return currentEmboss;
    if (cat === 'embossed-stickers') return 'std';
    if (norm(name).indexOf('emboss') !== -1) return 'std';
    return 'none';
  }

  // BASE MATERIAL only ('gloss' = white vinyl). The laminate travels
  // separately in mapLaminate(); never fold a laminate into finish here.
  // (pricing-engine's vpQuoteFinish() maps glitter-lam-* to gold/glitter for
  // the quote API -- that is a pricing mapping and is deliberately not used.)
  function mapFinish(name) {
    var matId = '';
    if (typeof MATERIALS !== 'undefined' && typeof currentMat !== 'undefined' && MATERIALS[currentMat]) {
      matId = lower(MATERIALS[currentMat].id || '');
    }
    if (matId === 'white-vinyl') return 'gloss';
    if (matId === 'clear') return 'clear';
    if (matId === 'holo') return 'holo';
    if (matId === 'glitter') return 'glitter';
    if (matId === 'mirror' || matId === 'chrome') return 'chrome';
    if (matId === 'gold') return 'gold';
    if (matId === 'reflective') return 'reflective';
    var n = norm(name);
    if (n.indexOf('gold') !== -1) return 'gold';
    if (n.indexOf('reflective') !== -1) return 'reflective';
    if (n.indexOf('holographic') !== -1 || n.indexOf('holo') !== -1) return 'holo';
    if (n.indexOf('glitter') !== -1) return 'glitter';
    if (n.indexOf('chrome') !== -1 || n.indexOf('mirror') !== -1) return 'chrome';
    return 'gloss';
  }

  // Laminate for VPQuote3D.set({ laminate }) from the configurator globals:
  //   currentSpecialty satin               -> 'satin'
  //   currentSpecialty glitter-lam-silver  -> 'glitter-silver'
  //   currentSpecialty glitter-lam-gold    -> 'glitter-gold'
  //   currentSpecialty glitter-lam-rainbow -> 'glitter-rainbow'
  //   currentSpecialty glitter-lam-red     -> 'glitter-red'      (Galactic Mars Red)
  //   currentSpecialty glitter-lam-neptune -> 'glitter-neptune'  (Galactic Neptune)
  //   currentSpecialty holo-lam-*          -> 'holo-*'           (Spectrum series)
  //   else currentFinish matte             -> 'matte'
  //   else                                 -> 'gloss'
  // (quote-3d.js validates against its LAMINATES list and falls back to gloss.)
  var LAM_MAP = {
    'satin': 'satin',
    'glitter-lam-silver': 'glitter-silver',
    'glitter-lam-stardust': 'glitter-stardust',
    'glitter-lam-gold': 'glitter-gold',
    'glitter-lam-rainbow': 'glitter-rainbow',
    'glitter-lam-red': 'glitter-red',
    'glitter-lam-neptune': 'glitter-neptune',
    'holo-lam-fracture': 'holo-fracture',
    'holo-lam-prismatic': 'holo-prismatic',
    'holo-lam-cosmic': 'holo-cosmic',
    'holo-lam-hex': 'holo-hex',
    'holo-lam-hearts': 'holo-hearts'
  };
  function mapLaminate() {
    if (typeof vpQuoteEmboss === 'function' && vpQuoteEmboss() !== 'none') return 'none';
    var sp = (typeof currentSpecialty === 'string') ? currentSpecialty : 'none';
    if (LAM_MAP[sp]) return LAM_MAP[sp];
    if (typeof currentFinish !== 'undefined' && currentFinish === 'matte') return 'matte';
    return 'gloss';
  }

  function dims() {
    if (typeof vpGetCurrentDims === 'function') {
      try {
        var d = vpGetCurrentDims();
        var w = d && parseFloat(d.w);
        var h = d && parseFloat(d.h);
        if (w > 0 && h > 0) return { w: w, h: h };
      } catch (e) {}
    }
    return { w: 3, h: 3 };
  }

  function jarPreviewActive() {
    if (typeof preview3D === 'undefined' || !preview3D.getCanvas) return false;
    var c = preview3D.getCanvas();
    return !!(c && c.id !== 'sticker-3d');
  }

  function sizeCanvas(canvas) {
    var preview = document.querySelector('.product-preview');
    var rect = preview ? preview.getBoundingClientRect() : { width: 320, height: 280 };
    var w = Math.max(1, Math.round(rect.width));
    var h = Math.max(1, Math.round(rect.height));
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.style.display = 'block';
    canvas.style.position = 'absolute';
    canvas.style.inset = '0';
    canvas.style.touchAction = 'none';
    if (canvas.width !== w) canvas.width = w;
    if (canvas.height !== h) canvas.height = h;
  }

  function setLoadHint(wrap, text) {
    if (!wrap) return;
    var el = document.getElementById('quote-3d-status');
    if (!text) {
      if (el && el.parentNode) el.parentNode.removeChild(el);
      return;
    }
    if (!el) {
      el = document.createElement('div');
      el.id = 'quote-3d-status';
      el.style.cssText = 'position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font:600 11px/1.4 var(--body,system-ui);letter-spacing:.08em;text-transform:uppercase;color:#666;pointer-events:none;z-index:3';
      wrap.appendChild(el);
    }
    el.textContent = text;
  }

  function stageEl() {
    return document.querySelector('.product-preview');
  }

  // The line under the stage. 10/12: sync() sets it too, so it has its product's wording before the card shows
  // (configurator.html shows the card after the first sync), not seconds later when the 3D viewer is ready: a longer
  // line ("Live kiss-cut sample with transfer film.") wrapped once more and moved the card on narrow phones.
  function setSampleNote(on) {
    var note = document.getElementById('stickerSampleNote');
    if (note) {
      note.hidden = !on;
      var cut = resolveCut(productName(), chipId());
      var shape = resolveShape(productName(), chipId());
      var size = dims();
      var sizing = shape === 'oval' && size.w === size.h ? ' Equal width and height make this oval circular.' : '';
      var sample = chipId() === 'emb-perf' ? 'Live perforated wrap-label sample.'
        : chipId() === 'vinyl-letter' ? 'Live cut-vinyl lettering sample.'
        : chipId() === 'front-adhes' ? 'Live front-adhesive sample, viewed from the adhesive side.'
        : cut === 'tape' ? 'Live kiss-cut sample with transfer film.'
        : cut === 'roll' ? 'Live roll and finish sample.'
        : cut === 'sheet' ? 'Live label sheet and finish sample.' : 'Live material and cut sample.';
      note.textContent = sample + sizing + ' Your artwork and final layout are confirmed in your proof.';
    }
  }

  function setCommandStage(on, finish) {
    setSampleNote(on);
    var preview = stageEl();
    if (!preview) return;
    if (on) {
      preview.classList.add('is-command-stage');
      preview.setAttribute('data-finish', finish || 'gloss');
    } else {
      preview.classList.remove('is-command-stage');
      preview.removeAttribute('data-finish');
    }
  }

  function showStickerWrap() {
    var wrap = document.getElementById('preview3dWrap');
    if (!wrap) return null;
    wrap.style.display = 'block';
    wrap.style.position = 'absolute';
    wrap.style.inset = '0';
    wrap.style.zIndex = '2';
    wrap.style.background = 'transparent';
    var img = document.getElementById('productImg');
    if (img) img.style.visibility = 'hidden';
    var hint = document.getElementById('previewHint');
    if (hint) hint.classList.add('hidden');
    var vt = document.getElementById('viewToggle');
    if (vt) vt.classList.remove('visible');
    var overlay = document.getElementById('artworkOverlay');
    if (overlay) overlay.style.visibility = 'hidden';
    var drag = document.getElementById('preview3dHint');
    if (drag) drag.style.display = 'block';
    return wrap;
  }

  function ensureCanvas(wrap) {
    var existing = wrap.querySelectorAll('canvas');
    var i;
    for (i = 0; i < existing.length; i++) {
      if (existing[i].id !== 'sticker-3d' && existing[i].parentNode) {
        existing[i].parentNode.removeChild(existing[i]);
      }
    }
    var canvas = document.getElementById('sticker-3d');
    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.id = 'sticker-3d';
      wrap.appendChild(canvas);
      mounted = false;
    } else if (canvas.parentNode !== wrap) {
      wrap.appendChild(canvas);
    }
    if (!mounted) sizeCanvas(canvas);
    return canvas;
  }

  function teardownSticker() {
    clearInterval(loadTimer);
    loadTimer = null;
    setLoadHint(document.getElementById('preview3dWrap'), '');
    if (window.VPQuote3D && typeof window.VPQuote3D.dispose === 'function') {
      try { window.VPQuote3D.dispose(); } catch (e) {}
    }
    var canvas = document.getElementById('sticker-3d');
    if (canvas && canvas.parentNode) canvas.parentNode.removeChild(canvas);
    mounted = false;
    lastPayloadKey = '';
    var overlay = document.getElementById('artworkOverlay');
    if (overlay) overlay.style.visibility = '';
    setCommandStage(false);
    if (jarPreviewActive()) return;
    var wrap = document.getElementById('preview3dWrap');
    if (wrap) {
      wrap.style.display = 'none';
      wrap.style.zIndex = '';
    }
    var img = document.getElementById('productImg');
    if (img) img.style.visibility = '';
  }

  function apply() {
    if (!isStickerProduct()) {
      teardownSticker();
      return;
    }
    if (!document.getElementById('sticker-3d')) mounted = false;

    // One WebGL at a time — drop jar/mylar before mounting the sticker scene.
    if (typeof preview3D !== 'undefined' && preview3D.deactivate && jarPreviewActive()) {
      preview3D.deactivate();
    }

    var wrap = showStickerWrap();
    if (!wrap) return;
    var canvas = ensureCanvas(wrap);
    var name = productName();
    var cut = resolveCut(name, chipId());
    var finish = mapFinish(name);
    if (mapLaminate() === 'matte' && finish === 'gloss') finish = 'matte';
    setCommandStage(true, finish);
    if (!cut) {
      teardownSticker();
      return;
    }
    if (!window.VPQuote3D) return;
    var d = dims();
    // The VP sample stays independent of stored customer artwork.
    var payload = {
      w: d.w,
      h: d.h,
      cut: cut,
      shape: resolveShape(name, chipId()),
      construction: chipId() === 'vinyl-letter' ? 'lettering' : chipId() === 'emb-perf' ? 'perforated' : chipId() === 'front-adhes' ? 'front-adhesive' : 'standard',
      emboss: cut === 'roll' || cut === 'tape' ? 'none' : mapEmboss(name),
      finish: mapFinish(name),
      laminate: mapLaminate(),
      // Shaped stickers and sheet labels are cut from the material, so circles, squares etc. take it
      // edge to edge; roll labels keep white stock around the art. Only sticker sheets carry the
      // material between the stickers; label sheets keep white backing paper (Josh, 2026-10-17).
      stock: cut === 'roll' ? 'white' : 'film',
      matrix: cut === 'sheet' && !(typeof currentCat !== 'undefined' && currentCat === 'labels'),
      // Special instructions "Cut directly to artwork edge" (Die Cut + Kiss Cut Transfer only, Josh 10/17).
      edge: typeof vpEdgeCutOn === 'function' && vpEdgeCutOn()
    };
    if (!window.VPQuote3D.ready || !window.VPQuote3D.ready()) {
      setLoadHint(wrap, 'Loading 3D finish…');
    }
    if (typeof window.VPQuote3D.mount === 'function') window.VPQuote3D.mount(canvas);
    // A laminate/emboss click reaches sync() up to three times (updatePrice,
    // the setter itself, and the click listener) -- only push a changed spec.
    var key = JSON.stringify(payload);
    if (!mounted || key !== lastPayloadKey) {
      if (typeof window.VPQuote3D.set === 'function') window.VPQuote3D.set(payload);
      lastPayloadKey = key;
    }
    mounted = true;
    if (window.VPQuote3D.ready && window.VPQuote3D.ready()) {
      clearInterval(loadTimer);
      loadTimer = null;
      setLoadHint(wrap, '');
    } else if (!loadTimer) {
      var n = 0;
      loadTimer = setInterval(function () {
        n += 1;
        var status = document.getElementById('quote-3d-status');
        if (window.VPQuote3D && window.VPQuote3D.ready && window.VPQuote3D.ready()) {
          clearInterval(loadTimer);
          loadTimer = null;
          setLoadHint(wrap, '');
        } else if (status && /could not|needs WebGL/i.test(status.textContent)) {
          clearInterval(loadTimer);
          loadTimer = null;
        } else if (n > 80) {
          clearInterval(loadTimer);
          loadTimer = null;
          setLoadHint(wrap, '3D still loading…');
        }
      }, 250);
    }
  }

  function waitAndApply() {
    if (window.VPQuote3D) {
      apply();
      return;
    }
    // Keep one module request in flight, even when the shopper switches products.
    // A failed load releases the guard so the next supported sync can retry.
    if (waiting) return;
    waiting = true;
    var script = document.createElement('script');
    script.type = 'module';
    var source = (window.VP_CDN+"quote-3d.js?v=38bc3b7040");
    if (moduleAttempts++) {
      // Browsers cache a failed module URL too; give an explicit retry a fresh entry.
      var retryUrl = new URL(source, document.baseURI);
      retryUrl.searchParams.set('vp-retry', moduleAttempts);
      source = retryUrl.href;
    }
    script.src = source;
    script.async = true;
    script.setAttribute('noshim', '');
    function failed() {
      waiting = false;
      script.remove();
    }
    script.onload = function () {
      waiting = false;
      if (window.VPQuote3D) sync();
      else failed();
    };
    script.onerror = failed;
    document.head.appendChild(script);
  }

  function sync() {
    if (!isStickerProduct()) {
      teardownSticker();
      return;
    }
    setSampleNote(true);
    waitAndApply();
  }

  function dispose() {
    teardownSticker();
  }

  window.vpStickerPreview = {
    supports: isStickerProduct,
    sync: sync,
    dispose: dispose
  };

  function laterSync() {
    setTimeout(function () {
      if (window.vpStickerPreview) window.vpStickerPreview.sync();
    }, 0);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.ps-chip') || t.closest('.mat-swatch') ||
        t.closest('#finishToggle') || t.closest('.lam-chip') ||
        t.closest('#btnMatte') || t.closest('#btnGlossy')) {
      laterSync();
    }
  });

  window.addEventListener('load', function () {
    if (window.vpStickerPreview) window.vpStickerPreview.sync();
  });
})();
